import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import sortable from 'sortablejs';
import app from '../../admin/app';
import Component from '../../common/Component';
import GroupBadge from '../../common/components/GroupBadge';
import Icon from '../../common/components/Icon';
import EditGroupModal from './EditGroupModal';
import sortGroups from '../../common/utils/sortGroups';
/**
 * A reusable component for displaying a list of groups in the admin interface,
 * with the ability to edit and reorder them.
 *
 * @property {Group[]} groups Required. Groups to display.
 *
 * @example
 * ```ts
 * const availableGroups = app.store
 *   .all<Group>('groups')
 *   .filter((group) => [Group.GUEST_ID, Group.MEMBER_ID].indexOf(group.id()!) === -1);
 *
 * <GroupBar groups={availableGroups} />
 * ```
 */
export default class GroupBar extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "groups", []);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.groups = sortGroups(this.attrs.groups);
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    this.groups = sortGroups(this.attrs.groups);
  }
  view() {
    return m("div", {
      className: "GroupBar",
      oncreate: this.onGroupBarCreate.bind(this)
    }, this.groups.map(group => m("button", {
      className: "Button Group",
      type: "button",
      "data-id": group.id(),
      onclick: () => app.modal.show(EditGroupModal, {
        group
      })
    }, m(GroupBadge, {
      group: group,
      className: "Group-icon",
      label: null
    }), m("span", {
      className: "Group-name"
    }, group.namePlural()))), m("button", {
      className: "Button Group Group--add",
      type: "button",
      onclick: () => app.modal.show(EditGroupModal)
    }, m(Icon, {
      name: "fas fa-plus",
      className: "Group-icon"
    }), m("span", {
      className: "Group-name"
    }, app.translator.trans('core.admin.permissions.new_group_button'))));
  }
  onGroupBarCreate(vnode) {
    sortable.create(vnode.dom, {
      group: 'groups',
      delay: 50,
      delayOnTouchOnly: true,
      touchStartThreshold: 5,
      animation: 150,
      swapThreshold: 0.65,
      dragClass: 'Group-Sortable-Dragging',
      ghostClass: 'Group-Sortable-Placeholder',
      filter: '.Group--add',
      onMove: evt => !evt.related.classList.contains('Group--add'),
      onSort: () => this.onSortUpdate()
    });
  }
  onSortUpdate() {
    const order = this.$('.Group:not(.Group--add)').map(function () {
      return $(this).data('id');
    }).get();
    order.forEach((id, i) => {
      var _app$store$getById;
      (_app$store$getById = app.store.getById('groups', id)) == null || _app$store$getById.pushData({
        attributes: {
          position: i
        }
      });
    });
    app.request({
      url: app.forum.attribute('apiUrl') + '/groups/order',
      method: 'POST',
      body: {
        order
      }
    });
  }
}
flarum.reg.add('core', 'admin/components/GroupBar', GroupBar);